import React, { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext(null);

const DICT = {
  en: {
    // shared
    "app.brand": "Relax MIS",
    "lang.switch_th": "ภาษาไทย",
    "lang.switch_en": "English",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.close": "Close",
    "common.back": "Back",
    "common.confirm": "Confirm",
    "common.email": "Email",
    "common.password": "Password",
    "common.name": "Name",
    "common.date": "Date",
    "common.amount": "Amount",
    "common.type": "Type",
    "common.details": "Details",
    "common.actions": "Actions",
    "common.optional": "optional",
    "common.upload": "Upload",
    "common.remove": "Remove",
    "common.total": "Total",
    "common.loading": "Loading…",
    "common.print": "Print",
    "common.email_report": "Email report",
    "common.enabled": "Enabled",
    "common.disabled": "Disabled",
    "common.status": "Status",
    "common.reactivate": "Reactivate",
    "common.disable": "Disable",
    "common.address": "Address",
    "common.town": "Town",
    "common.area": "Area",
    "common.telephone": "Telephone",
    "common.working_name": "Working name",
    "common.time": "Time",
    "common.duration": "Duration (mins)",
    "common.service": "Service",
    "common.price": "Price",
    "common.commission": "Commission",
    "common.shop_income": "Shop income",
    "common.income": "Income",
    "common.expenses": "Expenses",
    "common.profit": "Profit",
    "common.discount": "Discount",
    "common.other_income": "Other income",
    "common.top_up": "Guarantee top-up",
    "common.receipt": "Receipt",
    "common.note": "Note",
    "common.pin": "PIN",
    "common.new_pin": "New PIN",
    "common.current_pin": "Current PIN",
    "common.owner": "Owner",
    "common.manager": "Manager",
    "common.staff": "Staff",
    "common.overdue": "Overdue",
    "common.active": "Active",
    "common.customers": "Customers",
    "common.minutes": "Minutes",
    "common.start_date": "Start date",
    "common.end_date": "End date",
    "common.select_staff": "Select staff",
    "common.select_service": "Select service",
    "common.sign_out": "Sign out",

    // admin login
    "admin.login.title": "Super Admin",
    "admin.login.subtitle": "Sign in to manage white-label shops",
    "admin.login.email": "Administrator email",
    "admin.login.password": "Password",
    "admin.login.submit": "Sign in",
    "admin.login.forgot": "Forgot password?",
    "admin.login.demo_hint": "Preview a shop at",

    // admin dashboard
    "admin.dashboard.total_shops": "Total shops",
    "admin.dashboard.overdue_shops": "Overdue (4+ days)",
    "admin.dashboard.monthly_revenue": "Monthly revenue",
    "admin.dashboard.new_client": "Add new client",
    "admin.dashboard.overdue_list": "Overdue clients",
    "admin.dashboard.alphabet_directory": "Directory",
    "admin.dashboard.pick_letter": "Pick a letter to browse shops",
    "admin.dashboard.no_shops_letter": "No shops starting with this letter",
    "admin.dashboard.open_client": "Open client",
    "admin.dashboard.confirm_payment": "Confirm receipt",
    "admin.dashboard.reset_pin": "Reset owner PIN",
    "admin.dashboard.logout": "Sign out",
    "admin.dashboard.no_overdue": "All clients are up to date.",
    "admin.team.title": "Administrator team",
    "admin.team.subtitle": "Root only — invite, reset, or remove other administrators.",
    "admin.team.invite": "Invite administrator",

    // Admin top nav
    "admin.nav.edit_landing": "Edit landing",
    "admin.nav.promo_videos": "Promo Videos",

    // Admin promo videos page
    "admin.promo.title": "Promo Videos",
    "admin.promo.subtitle": "Play, download or share the Relax-MIS promotional videos.",
    "admin.promo.card_title_en": "Relax-MIS promo (English)",
    "admin.promo.card_title_th": "Relax-MIS promo (ไทย)",
    "admin.promo.download": "Download",
    "admin.promo.copy_link": "Copy link",
    "admin.promo.link_copied": "Link copied",
    "admin.promo.copy_failed": "Could not copy link",
    "admin.promo.tip": "Tip: download the file to attach it directly, or send the link.",

    // shop form
    "admin.shop.title_new": "Add new client",
    "admin.shop.title_edit": "Edit client",
    "admin.shop.shop_name": "Shop name",
    "admin.shop.street": "Number & street",
    "admin.shop.slug_preview": "Client URL",
    "admin.shop.logo": "Shop logo",
    "admin.shop.owner_name": "Owner name",
    "admin.shop.owner_email": "Owner email",
    "admin.shop.owner_pin": "Owner PIN (4 digits)",
    "admin.shop.managers": "Managers",
    "admin.shop.add_manager": "Add manager",
    "admin.shop.manager_pin": "Manager PIN",
    "admin.shop.manager_name": "Manager name",
    "admin.shop.renewal_date": "Renewal date",
    "admin.shop.monthly_fee": "Monthly fee (THB)",
    "admin.shop.opening_time": "Opening time (24h)",
    "admin.shop.closing_time": "Closing time (24h)",
    "attendance.hours": "Hours",

    // client landing
    "client.welcome": "Welcome to {name} Management Information System",
    "client.home": "Home",
    "client.input": "Input",
    "client.reports": "Reports",
    "client.administration": "Administration",
    "client.support": "Support",
    "client.kpi": "Key Performance Indicators",
    "client.disabled_notice": "Account has been de-activated until the renewal fee is paid.",
    "attendance.title": "Working today",
    "attendance.load_failed": "Could not load attendance",
    "attendance.no_staff": "No staff on the roster yet",

    // pin modal
    "pin.title": "Enter PIN",
    "pin.subtitle_input": "Anyone with a valid staff PIN can enter services.",
    "pin.subtitle_admin": "Manager or owner PIN required.",
    "pin.subtitle_reports": "Manager or owner PIN required.",
    "pin.enter": "Continue",
    "pin.invalid": "Invalid PIN",

    // input screen
    "input.title": "Service input",
    "input.recent_today": "Today's entries",
    "input.no_entries_today": "No entries recorded today yet.",
    "input.save": "Save entry",
    "input.saved": "Entry saved",
    "input.staff_working_name": "Staff working name",
    "input.staff_earnings": "Staff earnings",
    "input.your_entries_only": "Your entries only",
    "shop.idle_signout": "Signed out — 20 seconds inactive. Any unsaved entry was cancelled.",

    // Staff form (admin → Staff details)
    "staff_form.title_add": "Add staff",
    "staff_form.title_edit": "Edit staff",
    "staff_form.legal_name": "Legal name",
    "staff_form.working_name": "Working name",
    "staff_form.pin": "PIN (4 digits)",
    "staff_form.pin_blank_keep": "(blank = keep)",
    "staff_form.commission": "Commission %",
    "staff_form.guaranteed_pay": "Guaranteed daily pay (THB)",
    "staff_form.phone": "Phone",
    "staff_form.email": "Email",
    "staff_form.allow_signin": "Allow this staff to sign in with their PIN",
    "staff_form.photo_id": "Photo ID",
    "staff_form.cert": "Thai massage certificate",
    "staff_form.registration": "Therapist registration",
    "staff_form.cancel": "Cancel",
    "staff_form.save": "Save",
    "staff_form.add_cta": "Add staff",
    "staff_form.pin_required": "PIN required",
    "staff_form.generic_error": "Save failed",
    // Shared admin tabs
    "admin.col.date": "Date",
    "admin.col.category": "Category",
    "admin.col.details": "Details",
    "admin.col.amount": "Amount",
    "admin.col.receipt": "Receipt",
    "admin.col.actions": "Actions",
    "admin.col.working_name": "Working name",
    "admin.col.service_en": "Service (EN)",
    "admin.col.service_th": "Service (TH)",
    "admin.col.price_per_60": "Price / 60 min",
    "admin.btn.add": "Add",
    "admin.btn.cancel": "Cancel",
    "admin.btn.view": "View",
    "admin.btn.save": "Save",
    "admin.btn.rename": "Rename",
    "admin.btn.delete": "Delete",
    "admin.err.fill_fields": "Please fill in every field",
    "admin.err.generic": "Something went wrong",
    "admin.err.load_expenses": "Failed to load expenses",
    "admin.err.load_other": "Failed to load other income",
    "admin.err.load_menu": "Failed to load menu",
    "admin.err.load_categories": "Failed to load categories",
    "admin.err.upload_image_first": "Upload an image first",
    "admin.ok.expense_saved": "Expense saved",
    "admin.ok.category_added": "Category added",
    "admin.ok.category_renamed": "Category renamed",
    "admin.ok.category_removed": "Category removed",
    "admin.ok.service_added": "Service added",
    "admin.ok.updated": "Updated",
    "admin.ask.delete_expense": "Delete this expense?",
    "admin.ask.delete_other": "Delete this entry?",
    "admin.ask.delete_service": "Delete this service?",
    "admin.ask.delete_category": "Delete this category?",
    "admin.exp.categories": "Expense categories",
    "admin.exp.new_category": "New category",
    "admin.exp.receipt_image": "Receipt image",
    "admin.exp.details_placeholder": "Details",
    "admin.exp.amount_placeholder": "THB",
    "admin.exp.in_use_tip": "In use by {n} expense(s)",
    "admin.exp.no_expenses": "No expenses yet.",
    "admin.exp.no_categories": "No categories yet.",
    "admin.other.no_entries": "No entries yet.",
    "admin.menu.name_en_placeholder": "Service name (EN)",
    "admin.menu.name_th_placeholder": "ชื่อบริการ (ไทย)",
    "admin.menu.price_placeholder": "Price per 60 min (THB)",
    "admin.menu.add_service": "Add service",
    "admin.menu.no_services": "No services yet.",

    // admin hub
    "hub.title": "Administration",
    "hub.staff": "Staff details",
    "hub.expenses": "Expenses",
    "hub.menu": "Menu",
    "hub.licences": "Licences",
    "hub.staff_desc": "PIN codes, working names, contact, commission rates",
    "hub.expenses_desc": "Track expenses with receipt images",
    "hub.menu_desc": "Services offered and price per 60 minutes",
    "hub.licences_desc": "Operating licenses and notes",
    "hub.change_my_pin": "Change my PIN",
    "hub.pin_changed": "PIN updated",
    "hub.other_income": "Other income",
    "hub.other_income_desc": "Non-service income entries (e.g. girls release fee)",
    "hub.other.girls_release_fee": "Girls release fee",
    "hub.other.saved": "Entry saved",
    "profile.open": "Open my profile",
    "profile.save_email": "Save email",
    "profile.email_updated": "Email updated",
    "profile.load_failed": "Could not load profile",

    // reports
    "reports.title": "Reports",
    "reports.daily": "Daily work sheet",
    "reports.customers_by_time": "Customers by time",
    "reports.income_expenditure": "Income & Expenditure",
    "reports.profit": "Profit report",
    "reports.summary_profit": "Summary profit",
    "reports.staff_commission": "Staff commission",
    "reports.no_data": "No data for selected range.",
    "reports.no_email_on_file": "This staff member has no email on file.",
    "reports.emailed": "Report emailed",
    "reports.logo_required": "Upload a shop logo before printing. Ask your administrator to add one via Administration → Shop logo.",
    "reports.col.price_per_60m": "Price / 60m",
    "reports.col.guaranteed": "Guaranteed",
    "reports.col.top_up": "Top-up",
    "reports.col.total_pay": "Total pay",
    "reports.col.guaranteed_per_day": "Guaranteed / day",
    "reports.ie.expenditure": "Expenditure",
    "reports.ie.subtotal_services": "Subtotal — services",
    "reports.ie.total_income": "Total income",
    "reports.ie.total_expenditure": "Total expenditure",
    "reports.ie.no_service_income": "No service income",
    "reports.ie.no_other_income": "No other income",
    "shop.idle_warning": "Signing out in 5 seconds — move the mouse to stay",
    "shop.stay_signed_in": "Stay signed in",
    "kpi.title": "Key Performance Indicators",
    "kpi.range.daily": "Daily",
    "kpi.range.weekly": "Weekly",
    "kpi.range.monthly": "Monthly",
    "kpi.customers": "Customers",
    "kpi.income": "Income",
    "kpi.profit": "Profit",
    "kpi.income_per_customer": "Income / customer",
    "kpi.profit_per_customer": "Profit / customer",
    "kpi.customers_per_staff": "Customers / therapist",
    "kpi.top_services": "Top 10 services",
    "kpi.services_sold": "Services sold",
    "kpi.customers_by": "Customers by",
    "kpi.customers_by_hour": "Customers by hour of day",
    "kpi.income_vs_profit": "Income vs profit",
    "kpi.income_by_therapist": "Income by therapist",
    "kpi.hours_by_therapist": "Hours worked by therapist",
    "kpi.commission_by_therapist": "Commission by therapist",
    "kpi.revenue": "Revenue",
    "kpi.hours": "Hours",
    "kpi.commission": "Commission",
    "kpi.vs_dod": "vs yesterday",
    "kpi.vs_wow": "vs prior 7 days",
    "kpi.vs_mom": "vs prior 30 days",
    "kpi.top_performer_month": "Top performer last month",
    "kpi.top_performer_stats": "{income} across {customers} customers · {hours}h",
    "kpi.date_from": "From",
    "kpi.date_to": "To",
    "kpi.date_clear": "Clear date filter",

    // Public landing
    "public.admin_portal": "Admin Portal",
    "public.hero.eyebrow": "Management Information System · for massage shops",
    "public.hero.title_a": "Run your massage business",
    "public.hero.title_b": "with calm and clarity.",
    "public.hero.subtitle": "Relax-MIS is a bilingual, cloud-based management platform built for massage shops in Thailand. Track daily takings, pay staff fairly, and see every shop's performance in one quiet dashboard — in Thai or English, on any device.",
    "public.hero.cta_contact": "Contact us",
    "public.hero.cta_benefits": "See what you get",
    "public.hero.pill_bilingual": "ไทย / English",
    "public.hero.pill_multi_tenant": "Multi-shop ready",
    "public.hero.pill_reports": "Financial reporting",
    "public.sample.heading": "Monthly income",
    "public.sample.subtitle": "across all your shops",
    "public.sample.customers": "Customers",
    "public.sample.footer": "LIVE · UPDATED EVERY SHIFT",
    "public.benefits.title": "Everything a modern massage shop needs",
    "public.benefits.subtitle": "Stop using pen and paper to record transactions — modernise with our digital platform.",
    "public.benefit.multi.title": "Simple to Use",
    "public.benefit.multi.body": "We take care of all the set-up. Simple, easy input of data that automatically generates live management information to help you run your business profitably.",
    "public.benefit.reports.title": "Financial reporting that pays its way",
    "public.benefit.reports.body": "Daily, weekly, monthly and custom-range KPIs. Profit, income, commissions, expenses, guaranteed-pay top-ups, printable PDFs and Thai-ready tax lines — all one tap away.",
    "public.benefit.staff.title": "Bilingual staff management",
    "public.benefit.staff.body": "Rosters, PIN sign-in, guaranteed daily pay, commission tracking and attendance — all in Thai or English. Staff see only what they need; owners see everything.",
    "public.pricing.banner": "Modernise, digitise and monetise — for just 1,250 Baht per month.",
    "public.pricing.pitch": "No set-up fees. Fully managed launch. Your first full month of KPIs waiting on day two.",
    "public.pricing.point_1": "Unlimited staff, services and daily entries",
    "public.pricing.point_2": "Email support in English and Thai",
    "public.pricing.point_3": "Printable launch kit for every new shop",
    "public.pricing.form_label": "Start your shop",
    "public.enquiry.shop_name_placeholder": "Shop name",
    "public.enquiry.zip_placeholder": "Zip / postal code",
    "public.enquiry.required_shop": "Please fill in your name, shop name, zip code and phone",
    "public.agents.eyebrow": "Agents wanted",
    "public.agents.title": "Partner with Relax-MIS in your region.",
    "public.agents.body": "We are expanding across Thailand and are looking for commercially-minded agents to onboard massage shops, provide front-line support and share in recurring revenue.",
    "public.agents.point_1": "Attractive commission on every shop you bring on board",
    "public.agents.point_2": "Full training, printable launch kits and co-branded materials",
    "public.agents.point_3": "No technical background required — if you know the industry, we handle the tech",
    "public.agents.contact_label": "Enquiries",
    "public.agents.cta": "Email the team",
    "public.enquiry.name_placeholder": "Your name",
    "public.enquiry.region_placeholder": "Region or province",
    "public.enquiry.phone_placeholder": "Phone number",
    "public.enquiry.message_placeholder": "Message (optional)",
    "public.enquiry.submit": "Send enquiry",
    "public.enquiry.sending": "Sending…",
    "public.enquiry.required": "Please fill in your name, region and phone",
    "public.enquiry.success": "Thanks — we'll be in touch shortly",
    "public.enquiry.error": "Could not send enquiry. Please try again shortly.",
    "public.enquiry.thanks_title": "Thanks for reaching out",
    "public.enquiry.thanks_body": "Your enquiry is on its way to the Relax-MIS team. We'll call or email you within one business day.",
  },
  th: {
    "app.brand": "รีแลกซ์ MIS",
    "lang.switch_th": "ภาษาไทย",
    "lang.switch_en": "English",
    "common.save": "บันทึก",
    "common.cancel": "ยกเลิก",
    "common.delete": "ลบ",
    "common.edit": "แก้ไข",
    "common.close": "ปิด",
    "common.back": "ย้อนกลับ",
    "common.confirm": "ยืนยัน",
    "common.email": "อีเมล",
    "common.password": "รหัสผ่าน",
    "common.name": "ชื่อ",
    "common.date": "วันที่",
    "common.amount": "จำนวนเงิน",
    "common.type": "ประเภท",
    "common.details": "รายละเอียด",
    "common.actions": "จัดการ",
    "common.optional": "ไม่บังคับ",
    "common.upload": "อัปโหลด",
    "common.remove": "ลบออก",
    "common.total": "รวม",
    "common.loading": "กำลังโหลด…",
    "common.print": "พิมพ์",
    "common.email_report": "ส่งรายงานทางอีเมล",
    "common.enabled": "เปิดใช้",
    "common.disabled": "ปิดใช้",
    "common.status": "สถานะ",
    "common.reactivate": "เปิดใช้อีกครั้ง",
    "common.disable": "ปิดใช้งาน",
    "common.address": "ที่อยู่",
    "common.town": "เมือง",
    "common.area": "เขต",
    "common.telephone": "โทรศัพท์",
    "common.working_name": "ชื่อที่ใช้งาน",
    "common.time": "เวลา",
    "common.duration": "ระยะเวลา (นาที)",
    "common.service": "บริการ",
    "common.price": "ราคา",
    "common.commission": "ค่าคอมมิชชั่น",
    "common.shop_income": "รายได้ร้าน",
    "common.income": "รายรับ",
    "common.expenses": "รายจ่าย",
    "common.profit": "กำไร",
    "common.discount": "ส่วนลด",
    "common.other_income": "รายรับอื่น",
    "common.top_up": "เงินเพิ่มค่าประกัน",
    "common.receipt": "ใบเสร็จ",
    "common.note": "หมายเหตุ",
    "common.pin": "รหัส PIN",
    "common.new_pin": "PIN ใหม่",
    "common.current_pin": "PIN ปัจจุบัน",
    "common.owner": "เจ้าของ",
    "common.manager": "ผู้จัดการ",
    "common.staff": "พนักงาน",
    "common.overdue": "เกินกำหนด",
    "common.active": "ใช้งานอยู่",
    "common.customers": "ลูกค้า",
    "common.minutes": "นาที",
    "common.start_date": "วันเริ่ม",
    "common.end_date": "วันสิ้นสุด",
    "common.select_staff": "เลือกพนักงาน",
    "common.select_service": "เลือกบริการ",
    "common.sign_out": "ออกจากระบบ",

    "admin.login.title": "ผู้ดูแลระบบ",
    "admin.login.subtitle": "เข้าสู่ระบบเพื่อจัดการร้านค้า",
    "admin.login.email": "อีเมลผู้ดูแล",
    "admin.login.password": "รหัสผ่าน",
    "admin.login.submit": "เข้าสู่ระบบ",
    "admin.login.forgot": "ลืมรหัสผ่าน?",
    "admin.login.demo_hint": "ดูตัวอย่างร้านได้ที่",

    "admin.dashboard.total_shops": "ร้านทั้งหมด",
    "admin.dashboard.overdue_shops": "ค้างชำระ (4+ วัน)",
    "admin.dashboard.monthly_revenue": "รายได้รายเดือน",
    "admin.dashboard.new_client": "เพิ่มลูกค้าใหม่",
    "admin.dashboard.overdue_list": "ลูกค้าที่ค้างชำระ",
    "admin.dashboard.alphabet_directory": "ไดเรกทอรี",
    "admin.dashboard.pick_letter": "เลือกตัวอักษรเพื่อดูรายชื่อร้าน",
    "admin.dashboard.no_shops_letter": "ยังไม่มีร้านค้าขึ้นต้นด้วยอักษรนี้",
    "admin.dashboard.open_client": "เปิดหน้าร้าน",
    "admin.dashboard.confirm_payment": "ยืนยันการชำระ",
    "admin.dashboard.reset_pin": "รีเซ็ต PIN เจ้าของ",
    "admin.dashboard.logout": "ออกจากระบบ",
    "admin.dashboard.no_overdue": "ทุกร้านชำระครบแล้ว",

    // Admin top nav
    "admin.nav.edit_landing": "แก้ไขหน้าแรก",
    "admin.nav.promo_videos": "วิดีโอโฆษณา",

    // Admin promo videos page
    "admin.promo.title": "วิดีโอโฆษณา",
    "admin.promo.subtitle": "เล่น ดาวน์โหลด หรือแชร์วิดีโอโปรโมท Relax-MIS",
    "admin.promo.card_title_en": "วิดีโอโปรโมท Relax-MIS (English)",
    "admin.promo.card_title_th": "วิดีโอโปรโมท Relax-MIS (ไทย)",
    "admin.promo.download": "ดาวน์โหลด",
    "admin.promo.copy_link": "คัดลอกลิงก์",
    "admin.promo.link_copied": "คัดลอกแล้ว",
    "admin.promo.copy_failed": "คัดลอกลิงก์ไม่สำเร็จ",
    "admin.promo.tip": "เคล็ดลับ: ดาวน์โหลดไฟล์เพื่อแนบส่งโดยตรง หรือส่งเป็นลิงก์",

    "admin.shop.title_new": "เพิ่มลูกค้าใหม่",
    "admin.shop.title_edit": "แก้ไขข้อมูลลูกค้า",
    "admin.shop.shop_name": "ชื่อร้าน",
    "admin.shop.street": "เลขที่และถนน",
    "admin.shop.slug_preview": "ลิงก์ของร้าน",
    "admin.shop.logo": "โลโก้ร้าน",
    "admin.shop.owner_name": "ชื่อเจ้าของ",
    "admin.shop.owner_email": "อีเมลเจ้าของ",
    "admin.shop.owner_pin": "PIN เจ้าของ (4 หลัก)",
    "admin.shop.managers": "ผู้จัดการ",
    "admin.shop.add_manager": "เพิ่มผู้จัดการ",
    "admin.shop.manager_pin": "PIN ผู้จัดการ",
    "admin.shop.manager_name": "ชื่อผู้จัดการ",
    "admin.shop.renewal_date": "วันครบกำหนดต่ออายุ",
    "admin.shop.monthly_fee": "ค่าบริการรายเดือน (บาท)",
    "admin.shop.opening_time": "เวลาเปิด (24 ชม.)",
    "admin.shop.closing_time": "เวลาปิด (24 ชม.)",
    "attendance.hours": "เวลาเปิดทำการ",

    "client.welcome": "ยินดีต้อนรับสู่ระบบจัดการของ {name}",
    "client.home": "หน้าหลัก",
    "client.input": "บันทึกบริการ",
    "client.reports": "รายงาน",
    "client.administration": "จัดการ",
    "client.support": "ฝ่ายสนับสนุน",
    "client.kpi": "ตัวชี้วัดผลงาน",
    "client.disabled_notice": "บัญชีถูกระงับจนกว่าจะชำระค่าบริการรายเดือน",
    "attendance.title": "พนักงานที่ทำงานวันนี้",
    "attendance.load_failed": "ไม่สามารถโหลดข้อมูลการทำงาน",
    "attendance.no_staff": "ยังไม่มีพนักงาน",

    // Staff form (admin → รายละเอียดพนักงาน)
    "staff_form.title_add": "เพิ่มพนักงาน",
    "staff_form.title_edit": "แก้ไขพนักงาน",
    "staff_form.legal_name": "ชื่อ-นามสกุล",
    "staff_form.working_name": "ชื่อที่ใช้ทำงาน",
    "staff_form.pin": "PIN (4 หลัก)",
    "staff_form.pin_blank_keep": "(เว้นว่าง = คงเดิม)",
    "staff_form.commission": "ค่าคอมมิชชัน %",
    "staff_form.guaranteed_pay": "ค่าตอบแทนรายวันขั้นต่ำ (บาท)",
    "staff_form.phone": "โทรศัพท์",
    "staff_form.email": "อีเมล",
    "staff_form.allow_signin": "อนุญาตให้พนักงานเข้าสู่ระบบด้วย PIN",
    "staff_form.photo_id": "รูปถ่าย ID",
    "staff_form.cert": "ใบประกาศนวดไทย",
    "staff_form.registration": "ใบขึ้นทะเบียนผู้ให้บริการ",
    "staff_form.cancel": "ยกเลิก",
    "staff_form.save": "บันทึก",
    "staff_form.add_cta": "เพิ่มพนักงาน",
    "staff_form.pin_required": "ต้องระบุ PIN",
    "staff_form.generic_error": "บันทึกไม่สำเร็จ",
    // Shared admin tabs
    "admin.col.date": "วันที่",
    "admin.col.category": "หมวดหมู่",
    "admin.col.details": "รายละเอียด",
    "admin.col.amount": "จำนวนเงิน",
    "admin.col.receipt": "ใบเสร็จ",
    "admin.col.actions": "การกระทำ",
    "admin.col.working_name": "ชื่อที่ใช้ทำงาน",
    "admin.col.service_en": "บริการ (EN)",
    "admin.col.service_th": "บริการ (ไทย)",
    "admin.col.price_per_60": "ราคา / 60 นาที",
    "admin.btn.add": "เพิ่ม",
    "admin.btn.cancel": "ยกเลิก",
    "admin.btn.view": "ดู",
    "admin.btn.save": "บันทึก",
    "admin.btn.rename": "เปลี่ยนชื่อ",
    "admin.btn.delete": "ลบ",
    "admin.err.fill_fields": "กรุณากรอกข้อมูลให้ครบทุกช่อง",
    "admin.err.generic": "มีบางอย่างผิดพลาด",
    "admin.err.load_expenses": "โหลดรายจ่ายไม่สำเร็จ",
    "admin.err.load_other": "โหลดรายได้อื่นไม่สำเร็จ",
    "admin.err.load_menu": "โหลดเมนูไม่สำเร็จ",
    "admin.err.load_categories": "โหลดหมวดหมู่ไม่สำเร็จ",
    "admin.err.upload_image_first": "กรุณาอัปโหลดรูปก่อน",
    "admin.ok.expense_saved": "บันทึกรายจ่ายแล้ว",
    "admin.ok.category_added": "เพิ่มหมวดหมู่แล้ว",
    "admin.ok.category_renamed": "เปลี่ยนชื่อหมวดหมู่แล้ว",
    "admin.ok.category_removed": "ลบหมวดหมู่แล้ว",
    "admin.ok.service_added": "เพิ่มบริการแล้ว",
    "admin.ok.updated": "อัปเดตแล้ว",
    "admin.ask.delete_expense": "ลบรายจ่ายนี้?",
    "admin.ask.delete_other": "ลบรายการนี้?",
    "admin.ask.delete_service": "ลบบริการนี้?",
    "admin.ask.delete_category": "ลบหมวดหมู่นี้?",
    "admin.exp.categories": "หมวดหมู่รายจ่าย",
    "admin.exp.new_category": "หมวดหมู่ใหม่",
    "admin.exp.receipt_image": "รูปใบเสร็จ",
    "admin.exp.details_placeholder": "รายละเอียด",
    "admin.exp.amount_placeholder": "บาท",
    "admin.exp.in_use_tip": "ใช้งานอยู่ใน {n} รายการ",
    "admin.exp.no_expenses": "ยังไม่มีรายจ่าย",
    "admin.exp.no_categories": "ยังไม่มีหมวดหมู่",
    "admin.other.no_entries": "ยังไม่มีรายการ",
    "admin.menu.name_en_placeholder": "ชื่อบริการ (EN)",
    "admin.menu.name_th_placeholder": "ชื่อบริการ (ไทย)",
    "admin.menu.price_placeholder": "ราคา / 60 นาที (บาท)",
    "admin.menu.add_service": "เพิ่มบริการ",
    "admin.menu.no_services": "ยังไม่มีบริการ",

    "pin.title": "กรอก PIN",
    "pin.subtitle_input": "พนักงานที่มี PIN สามารถบันทึกบริการได้",
    "pin.subtitle_admin": "ต้องใช้ PIN ของผู้จัดการหรือเจ้าของ",
    "pin.subtitle_reports": "ต้องใช้ PIN ของผู้จัดการหรือเจ้าของ",
    "pin.enter": "เข้าใช้งาน",
    "pin.invalid": "PIN ไม่ถูกต้อง",

    "input.title": "บันทึกบริการ",
    "input.recent_today": "รายการวันนี้",
    "input.no_entries_today": "ยังไม่มีบันทึกบริการวันนี้",
    "input.save": "บันทึกรายการ",
    "input.saved": "บันทึกสำเร็จ",
    "input.staff_working_name": "ชื่อพนักงาน",
    "input.staff_earnings": "ค่าตอบแทนพนักงาน",
    "input.your_entries_only": "บันทึกได้เฉพาะของตนเอง",
    "shop.idle_signout": "ออกจากระบบ — ไม่มีการใช้งาน 20 วินาที ข้อมูลที่ยังไม่ได้บันทึกถูกยกเลิก",

    "hub.title": "หน้าจัดการ",
    "hub.staff": "ข้อมูลพนักงาน",
    "hub.expenses": "รายจ่าย",
    "hub.menu": "เมนูบริการ",
    "hub.licences": "ใบอนุญาต",
    "hub.staff_desc": "PIN ชื่อในงาน ติดต่อ อัตราค่าคอมมิชชั่น",
    "hub.expenses_desc": "บันทึกรายจ่ายพร้อมรูปใบเสร็จ",
    "hub.menu_desc": "บริการที่ให้และราคาต่อ 60 นาที",
    "hub.licences_desc": "ใบอนุญาตประกอบกิจการและหมายเหตุ",
    "hub.change_my_pin": "เปลี่ยน PIN ของฉัน",
    "hub.pin_changed": "อัปเดต PIN แล้ว",
    "hub.other_income": "รายรับอื่น",
    "hub.other_income_desc": "รายการรายรับที่ไม่ใช่ค่าบริการ (เช่น ค่าออกงานพนักงาน)",
    "hub.other.girls_release_fee": "ค่าออกงานพนักงาน",
    "hub.other.saved": "บันทึกแล้ว",
    "profile.open": "เปิดโปรไฟล์ของฉัน",
    "profile.save_email": "บันทึกอีเมล",
    "profile.email_updated": "อัปเดตอีเมลแล้ว",
    "profile.load_failed": "ไม่สามารถโหลดโปรไฟล์",

    "reports.title": "รายงาน",
    "reports.daily": "รายงานประจำวัน",
    "reports.customers_by_time": "ลูกค้าตามเวลา",
    "reports.income_expenditure": "รายรับ-รายจ่าย",
    "reports.profit": "รายงานกำไร",
    "reports.summary_profit": "สรุปกำไร",
    "reports.staff_commission": "ค่าคอมพนักงาน",
    "reports.no_data": "ไม่พบข้อมูลในช่วงที่เลือก",
    "reports.no_email_on_file": "พนักงานคนนี้ยังไม่ได้ระบุอีเมล",
    "reports.emailed": "ส่งอีเมลรายงานแล้ว",
    "reports.logo_required": "อัปโหลดโลโก้ร้านก่อนจึงจะพิมพ์ได้ แจ้งผู้ดูแลระบบเพื่อเพิ่มโลโก้",
    "reports.col.price_per_60m": "ราคา/60 นาที",
    "reports.col.guaranteed": "ขั้นต่ำ",
    "reports.col.top_up": "เงินเพิ่ม",
    "reports.col.total_pay": "รายได้รวม",
    "reports.col.guaranteed_per_day": "ขั้นต่ำ/วัน",
    "reports.ie.expenditure": "รายจ่าย",
    "reports.ie.subtotal_services": "รวมบริการ",
    "reports.ie.total_income": "รายรับรวม",
    "reports.ie.total_expenditure": "รายจ่ายรวม",
    "reports.ie.no_service_income": "ไม่มีรายได้จากบริการ",
    "reports.ie.no_other_income": "ไม่มีรายได้อื่น",
    "shop.idle_warning": "จะออกจากระบบใน 5 วินาที — ขยับเมาส์เพื่อใช้งานต่อ",
    "shop.stay_signed_in": "ใช้งานต่อ",
    "kpi.title": "ตัวชี้วัดผลงาน",
    "kpi.range.daily": "รายวัน",
    "kpi.range.weekly": "รายสัปดาห์",
    "kpi.range.monthly": "รายเดือน",
    "kpi.customers": "ลูกค้า",
    "kpi.income": "รายรับ",
    "kpi.profit": "กำไร",
    "kpi.income_per_customer": "รายรับต่อลูกค้า",
    "kpi.profit_per_customer": "กำไรต่อลูกค้า",
    "kpi.customers_per_staff": "ลูกค้าต่อพนักงาน",
    "kpi.top_services": "10 บริการยอดนิยม",
    "kpi.services_sold": "บริการที่ขายได้",
    "kpi.customers_by": "ลูกค้าตาม",
    "kpi.customers_by_hour": "ลูกค้าตามช่วงเวลา",
    "kpi.income_vs_profit": "รายรับเทียบกำไร",
    "kpi.income_by_therapist": "รายรับตามพนักงาน",
    "kpi.hours_by_therapist": "ชั่วโมงทำงานตามพนักงาน",
    "kpi.commission_by_therapist": "ค่าคอมมิชชันตามพนักงาน",
    "kpi.revenue": "รายรับ",
    "kpi.hours": "ชั่วโมง",
    "kpi.commission": "ค่าคอมมิชชัน",
    "kpi.vs_dod": "เทียบวันก่อน",
    "kpi.vs_wow": "เทียบ 7 วันก่อน",
    "kpi.vs_mom": "เทียบ 30 วันก่อน",
    "kpi.top_performer_month": "สุดยอดพนักงานเดือนที่แล้ว",
    "kpi.top_performer_stats": "{income} จากลูกค้า {customers} คน · {hours} ชม.",
    "kpi.date_from": "จาก",
    "kpi.date_to": "ถึง",
    "kpi.date_clear": "ล้างตัวกรองวันที่",

    // Public landing
    "public.admin_portal": "เข้าสู่ระบบผู้ดูแล",
    "public.hero.eyebrow": "ระบบจัดการข้อมูล · สำหรับร้านนวด",
    "public.hero.title_a": "ดูแลร้านนวดของคุณ",
    "public.hero.title_b": "อย่างเป็นระเบียบและชัดเจน",
    "public.hero.subtitle": "Relax-MIS คือแพลตฟอร์มบริหารร้านนวดบนคลาวด์ รองรับทั้งภาษาไทยและอังกฤษ บันทึกยอดรายวัน จ่ายค่าตอบแทนพนักงานอย่างเป็นธรรม และดูภาพรวมทุกสาขาได้บนแดชบอร์ดเดียว ทุกอุปกรณ์",
    "public.hero.cta_contact": "ติดต่อเรา",
    "public.hero.cta_benefits": "ดูสิ่งที่คุณได้",
    "public.hero.pill_bilingual": "ไทย / English",
    "public.hero.pill_multi_tenant": "รองรับหลายสาขา",
    "public.hero.pill_reports": "รายงานทางการเงิน",
    "public.sample.heading": "รายได้ประจำเดือน",
    "public.sample.subtitle": "รวมทุกสาขา",
    "public.sample.customers": "ลูกค้า",
    "public.sample.footer": "ข้อมูลสด · อัปเดตทุกกะ",
    "public.benefits.title": "ทุกอย่างที่ร้านนวดยุคใหม่ต้องการ",
    "public.benefits.subtitle": "เลิกใช้ปากกาและกระดาษจดรายการ — ยกระดับร้านของคุณด้วยแพลตฟอร์มดิจิทัลของเรา",
    "public.benefit.multi.title": "ใช้งานง่าย",
    "public.benefit.multi.body": "เราดูแลการติดตั้งให้ทั้งหมด ป้อนข้อมูลง่าย ๆ ระบบจะสร้างข้อมูลบริหารแบบเรียลไทม์โดยอัตโนมัติ ช่วยให้คุณบริหารร้านอย่างทำกำไร",
    "public.benefit.reports.title": "รายงานทางการเงินที่คุ้มค่า",
    "public.benefit.reports.body": "KPI รายวัน รายสัปดาห์ รายเดือน และช่วงวันที่กำหนดเอง ครบทั้งกำไร รายรับ ค่าคอมมิชชัน ค่าใช้จ่าย ค่ารับประกันขั้นต่ำ ส่งออก PDF และบรรทัดภาษีภาษาไทย — เพียงแตะเดียว",
    "public.benefit.staff.title": "จัดการพนักงานสองภาษา",
    "public.benefit.staff.body": "ตารางเวร, การเข้าใช้งานด้วย PIN, ค่าตอบแทนรายวันขั้นต่ำ, การคำนวณค่าคอมมิชชัน และการเช็กชื่อ — ครบทั้งไทยและอังกฤษ พนักงานเห็นเฉพาะที่จำเป็น เจ้าของเห็นทุกอย่าง",
    "public.pricing.banner": "ยกระดับร้านสู่ดิจิทัลและสร้างรายได้ — เพียง 1,250 บาทต่อเดือน",
    "public.pricing.pitch": "ไม่มีค่าติดตั้ง เราดูแลให้ครบ เริ่มดูข้อมูล KPI ได้ตั้งแต่วันที่ 2",
    "public.pricing.point_1": "พนักงาน บริการ และข้อมูลรายวันไม่จำกัด",
    "public.pricing.point_2": "ซัพพอร์ตทางอีเมลทั้งภาษาไทยและอังกฤษ",
    "public.pricing.point_3": "ชุดเปิดตัวพร้อมพิมพ์สำหรับทุกสาขา",
    "public.pricing.form_label": "เริ่มต้นร้านของคุณ",
    "public.enquiry.shop_name_placeholder": "ชื่อร้าน",
    "public.enquiry.zip_placeholder": "รหัสไปรษณีย์",
    "public.enquiry.required_shop": "กรุณากรอกชื่อ ชื่อร้าน รหัสไปรษณีย์ และเบอร์โทร",
    "public.agents.eyebrow": "รับสมัครตัวแทน",
    "public.agents.title": "ร่วมเป็นพาร์ทเนอร์ Relax-MIS ในพื้นที่ของคุณ",
    "public.agents.body": "เรากำลังขยายทั่วประเทศไทย และกำลังมองหาตัวแทนที่มีสายตาเชิงพาณิชย์ เพื่อแนะนำร้านนวดเข้าสู่ระบบ ให้บริการแนวหน้า และแบ่งปันรายได้แบบต่อเนื่อง",
    "public.agents.point_1": "ค่าคอมมิชชันน่าสนใจทุกร้านที่คุณพาเข้ามา",
    "public.agents.point_2": "มีอบรม ชุดเปิดตัวพร้อมพิมพ์ และสื่อโคแบรนด์ครบ",
    "public.agents.point_3": "ไม่จำเป็นต้องมีพื้นฐานเทคนิค — คุณรู้วงการ เราดูแลเทคโนโลยีให้",
    "public.agents.contact_label": "สอบถาม",
    "public.agents.cta": "ส่งอีเมลหาเรา",
    "public.enquiry.name_placeholder": "ชื่อของคุณ",
    "public.enquiry.region_placeholder": "ภูมิภาคหรือจังหวัด",
    "public.enquiry.phone_placeholder": "หมายเลขโทรศัพท์",
    "public.enquiry.message_placeholder": "ข้อความ (ไม่บังคับ)",
    "public.enquiry.submit": "ส่งคำสอบถาม",
    "public.enquiry.sending": "กำลังส่ง…",
    "public.enquiry.required": "กรุณากรอกชื่อ ภูมิภาค และเบอร์โทร",
    "public.enquiry.success": "ขอบคุณ ทีมงานจะติดต่อกลับเร็ว ๆ นี้",
    "public.enquiry.error": "ส่งคำสอบถามไม่สำเร็จ กรุณาลองใหม่",
    "public.enquiry.thanks_title": "ขอบคุณที่ติดต่อเรา",
    "public.enquiry.thanks_body": "คำสอบถามของคุณถูกส่งไปยังทีม Relax-MIS แล้ว เราจะโทรหรืออีเมลกลับภายใน 1 วันทำการ",
  },
};

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("relax_lang") || "en");
  useEffect(() => {
    localStorage.setItem("relax_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (key, params) => {
    const s = (DICT[lang] && DICT[lang][key]) || DICT.en[key] || key;
    if (!params) return s;
    return s.replace(/\{(\w+)\}/g, (_, k) => (params[k] != null ? String(params[k]) : ""));
  };
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  const c = useContext(LangContext);
  if (!c) throw new Error("useLang outside provider");
  return c;
}
